import { Component, ViewChild } from '@angular/core';
import {
  DsButtonModule,
  DsFormFieldModule,
  DsLabelModule,
  DsLoadingAreaConfiguration,
  DsLoadingAreaService,
  DsModalModule,
  DsToastModel,
  DsToastService,
} from '@bmw-ds/components';
import { FormsModule } from '@angular/forms';
import { DemoQuoteRequest } from '../../../models/request-quote.model';
import { StockService } from '../../../services/stock.service';
import { ShowQuoteComponent } from '../showQoute/show-quote.component';
import { UserInfoService } from '../../../services/user-info.service';

@Component({
  selector: 'app-request-quote',
  templateUrl: './request-quote.component.html',
  imports: [
    DsModalModule,
    DsFormFieldModule,
    DsLabelModule,
    FormsModule,
    ShowQuoteComponent,
    DsButtonModule,
  ],
  styleUrls: ['./request-quote.component.scss'],
})
export class RequestQuoteComponent {
  @ViewChild(ShowQuoteComponent)
  showQuoteComponent!: ShowQuoteComponent;

  constructor(
    private stockService: StockService,
    private loadingAreaService: DsLoadingAreaService,
    private toastService: DsToastService,
    private userInfoService: UserInfoService
  ) {}
  loadingAreaConfig: DsLoadingAreaConfiguration = { id: 'bodyLoading' };

  demoStockReplshModalIsOpen = false;
  modalData = {
    requesterName: '',
    vin: '',
  };

  addToast(tone: 'critical' | 'positive' | 'neutral', teastText: string): void {
    this.toastService.pushToast({
      id: 'error-toast',
      tone: tone,
      toastText: teastText,
    } as DsToastModel);
  }

  demoQuoteRequest: DemoQuoteRequest = {
    vin: '',
    customerName: '',
    indicator: '',
    userid: '',
  };

  onTextChange(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    this.customerNameModel = inputElement.value;
  }

  customerNameModel: string = '';

  requestQuote(): void {
    this.loadingAreaConfig = {
      id: 'bodyLoading',
      loadingTitle: 'Loading',
      loadingText: 'Please wait',
    };
    this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);
    this.demoQuoteRequest.userid = this.userInfoService.getUserId();
    this.demoQuoteRequest.vin = this.modalData.vin;
    this.demoQuoteRequest.customerName = this.customerNameModel;
    this.demoQuoteRequest.indicator = 'V';

    this.stockService.requestQuote(this.demoQuoteRequest).subscribe(
      (response) => {
        this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
        console.log('Quote requested successfully:', response);
        this.loadingAreaService.removeLoadingArea('bodyLoading');
        this.addToast(
          'positive',
          'Quote requested successfully for VIN: ' + this.demoQuoteRequest.vin
        );

        if (response.message && response.message.messageText !== '') {
          this.addToast('critical', response.message.messageText);
        } else {
          this.demoStockReplshModalIsOpen = false;
          this.showQuoteComponent.demoQuoteResponse = {
            vin: response.demoQuoteData.vin,
            quoteDate: response.demoQuoteData.quoteDate,
            expiryDate: response.demoQuoteData.expiryDate,
            customer: response.demoQuoteData.customer,
            modelDescription: response.demoQuoteData.modelDescription,
            series: response.demoQuoteData.series,
            bodyno: response.demoQuoteData.bodyno,
            daysFromRetail: response.demoQuoteData.daysFromRetail,
            registrationDate: response.demoQuoteData.registrationDate,
            mileage: response.demoQuoteData.mileage,
            estimatedPrice: response.demoQuoteData.estimatedPrice,
            requestorName: response.demoQuoteData.requestorName,
            requestorEmail: response.demoQuoteData.requestorEmail,
            disclaimer: response.disclaimer,
          };
          this.showQuoteComponent.qouteModalIsOpen = true;
        }
      },
      (error) => {
        this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
        console.error('Error requesting quote:', error);
        this.addToast(
          'critical',
          'Failed to request quote for VIN: ' + this.demoQuoteRequest.vin
        );
      }
    );

    console.log('Requesting vehicle with VIN:', this.modalData.vin);
  }

  closeRequestQuoteModal() {
    this.modalData.requesterName = '';
    this.customerNameModel = '';
    const customerNameInput = document.getElementById(
      'customerNameText'
    ) as HTMLInputElement;
    if (customerNameInput) {
      customerNameInput.value = '';
    }
    this.demoStockReplshModalIsOpen = false;
  }
}
